import { render, staticRenderFns } from "./AppConfigRulesRegister.vue?vue&type=template&id=65eae573"
import script from "./AppConfigRulesRegister.vue?vue&type=script&lang=js"
export * from "./AppConfigRulesRegister.vue?vue&type=script&lang=js"
import style0 from "./AppConfigRulesRegister.vue?vue&type=style&index=0&id=65eae573&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports